import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { ONTBlockFieldEnum } from "../../data/enums";

export namespace NetworkONTBlockValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            field: v.picklist(ONTBlockFieldEnum.values),
            value: baseVals.string(),
            block: v.boolean(),
            debug: v.boolean(),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            block: v.exactOptional(v.boolean()),
            debug: v.exactOptional(v.boolean()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );
}
